import React, {useContext} from "react";
import {FormattedMessage} from "react-intl";

import JobBoardFiltersContext from "./JobBoardFiltersContext";

const JobBoardFiltersPopupResetButton = () => {

  const [, setPopupFilters] = useContext(JobBoardFiltersContext);

  return (
    <button className="jb-filters__reset" onClick={() => setPopupFilters([])}>
      <FormattedMessage id="jobBoard.filters.popup.resetFiltersButton"/>
    </button>
  )
};

export default JobBoardFiltersPopupResetButton
